import ResetClientSecretConfirmModal from './ResetClientSecretConfirmModal.container';

export default ResetClientSecretConfirmModal;
